import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function ResolveBooking({ cancelledId, fetchOverDrafts, setCancelledId }: any) {
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [trackingId, setTrackingId] = useState('')

  async function resolveBooking() {
    const data = {
      trackingId: trackingId,
    }
    if (trackingId.length < 4) {
      notify('warn', 'tracking Id is required')
      return
    }
    setCancelLoading(true)
    post(`admin/resolve-cancelled-booking/${cancelledId}`, data, null)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Booking Resolved')
          setCancelledId('')
          fetchOverDrafts(1, 10)
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Resolve Cancelled booking</h1>
        <p>
          Note: this will resolve the booking and cancel the booking with the
          tracking ID.
        </p>
        <input
          type='text'
          placeholder='Enter Tracking ID'
          value={trackingId}
          onChange={(e) => setTrackingId(e.target.value)}
        />
        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setCancelledId('')}>Cancel</button>
            <button className='proceed' onClick={resolveBooking}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ResolveBooking
// import { useState } from 'react'
